import React, { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { getFullNameUser } from "../../Helpers/Utils/Common";
import moment from "moment";
import { Space } from "antd";

export default function DispatchSlip(props) {
  const componentRef = useRef();
  const { table, orderItems, additionalItems, purpose, tableTo, printerName } =props;
  const foodServer = getFullNameUser();
  React.useEffect(() => {
    if (purpose === "order slip") {
      props.setBulkPrintRef(componentRef.current);
    }
  }, []);

  return (
    <div ref={componentRef} className="d-flex justify-content-center">
      <div className="dispatch-receipt">
      <Row className="text-center">{window.store_name}</Row>
        {purpose !== "transfer" && (
          <Row className="w-100">BUZZER # {table}</Row>
        )}
        <Row className="text-center">{purpose?.toUpperCase()}</Row>
        {purpose === "transfer" && (
          <Row className="w-100">
            FROM BUZZER # {table?.toUpperCase()} TO BUZZER #
            {tableTo?.toUpperCase()}{" "}
          </Row>
        )}
        <Row className="mt-3">
          {orderItems?.map((order) => (
            <>
              <Row className="d-flex justify-content-between">
                <Col xs={3} className="text-center">
                  {order.qty}
                </Col>
                <Col xs={9} className="text-start">
                  {order.menu_name}
                  {order.order_type === "takeout" || order.pricelist === "takeout"
                    ? ""
                    : ""}{" "}
                </Col>
              </Row>
              {
                order?.remarks && (
                  <Row className="d-flex justify-content-between">
                    <Col xs={12} className="text-center">
                      * {order.remarks}
                    </Col>
                  </Row>
                )
              }
              {order.menu_modifiers && (
                <div>
                  {order?.menu_modifiers?.map((menu) => (
                    <Row className="d-flex justify-content-between">
                      <Col xs={3} className="text-center"></Col>
                      <Col xs={9} className="text-start">
                        <Space className="ms-4">{`  -${menu.modifier_name}`}</Space>
                      </Col>
                    </Row>
                  ))}
                </div>
              )}
            </>
          ))}
        </Row>
        {additionalItems && additionalItems.length > 0 && (
          <Row className="mt-3">
            <Row className="text-center">ADDITIONAL ITEMS</Row>
            {additionalItems.map((item) => (
              <Row className="d-flex justify-content-between">
                <Col xs={3} className="text-center">
                  {item.counter}
                </Col>
                <Col xs={9} className="text-start">
                  {item.name}
                  {item.order_type === "takeout" || item.pricelist === "takeout"
                    ? "  🥡"
                    : ""}{" "}
                </Col>
              </Row>
            ))}
          </Row>
        )}
         
        <Row className="mt-4 text-center">{foodServer}</Row>
        {purpose === "order slip" && (
          <Row className="text-center">PRINTER: {printerName}</Row>
        )}
        <Row className="text-center">
          {moment().format("MMM DD, YYYY hh:mm A")}
        </Row>
      </div>
    </div>
  );
}
